import { ConsentModel } from './../../Models/ConsentModel';
import { Component, DoCheck, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConsentToAccessService } from '../../../module/consent-to-access/consent-to-access.service';
import { LoginService } from '../../services/login.service';
import { BreadcrumbService } from '../../services/breadcrumb';
import { Subscription, firstValueFrom, skip } from 'rxjs';
import { LanguageService } from '../../services/language.service';
import { NotificationService } from '../../services/notification.service';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../../environments/environment.development';
import { RegisterModalComponent } from '../register-modal/register-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, DoCheck, OnDestroy {
  clientlogo = 'assets/images/logo/Logo.png';
  breadcrumbs: { label: string; link: string; skip?: boolean }[] = [];
  @ViewChild('register') registerModal!: RegisterModalComponent;
  public menuitems: any[] = [];
  private RawBreadCrumb = [];

  languageSubscription: Subscription;
  private notificationRawData: any = null;
  protected notifyCount: number = 0;
  userData: any;
  activeLanguage: any;
  currentPath: any;
  citizenData: any;

  constructor(
    public consentAccessService: ConsentToAccessService,
    private router: Router,
    private loginService: LoginService,
    private breadcrumbService: BreadcrumbService,
    public langService: LanguageService,
    public citizenService: NotificationService,
    private renderer: Renderer2,
  ) {
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.RawBreadCrumb = breadcrumbs;
      if (this.langService.currentLanguage == 'en') {
        this.breadcrumbs = breadcrumbs;
      } else {
        let TranslatedData = [];
        breadcrumbs.map((data: any) => {
          TranslatedData.push(data);
        });
        this.breadcrumbs = TranslatedData;
      }
    });
  }

  dropdownVisible: boolean = false;
  isMobile: boolean = false;
  biggestDatePlus6Months: string | null = null;
  ngOnInit(): void {

    this.currentPath = this.router.url;
    this.listenToNotifyChanges();
    this.SubscribeLanguage();
    if (this.consentAccessService.isLoggedIn) {
      this.GetCitizenNotification();
      this.SwitchMenu();
    } else {
      this.SwitchMenu();
    }
    this.loginService.logoutObservable.subscribe(() => {
      this.reloadHeader(); // Method to reload the header
      this.currentPath = this.router.url;
    });
    this.userData = JSON.parse(sessionStorage.getItem('userData'));
    this.listenToLanguageChanges();

    this.checkScreenSize();
    this.biggestDatePlus6Months = sessionStorage.getItem('biggest_date_plus_6_months');
  }

  checkScreenSize() {
    if (window.innerWidth <= 992) {
      this.dropdownVisible = true;
      this.isMobile = true;
    } else {
      this.dropdownVisible = false;
      this.isMobile = false;
    }
  }

  toggleDropdown(event: MouseEvent) {
    this.dropdownVisible = !this.dropdownVisible;
  }

  onResize(event: any) {
    this.checkScreenSize();
  }

  reloadHeader() {
    this.ngOnInit(); // Or whatever method that updates your header component
  }
  visiblevleid: boolean = false;
  vleid: any;
  logouttitle: any = 'Logout';
  SwitchMenu() {
    let cuid: any;
    let existingData = sessionStorage.getItem('userData');
    let parsedData = existingData ? JSON.parse(existingData) : {};

    this.menuitems = [];
    if (
      this.consentAccessService.isLoggedIn &&
      parsedData.citizen_unique_id != null
    ) {
      this.getProfile(parsedData.citizen_unique_id);
      this.logouttitle = 'Logout';
      if (this.consentAccessService.isVLEuser == true) {
        this.visiblevleid = true;
        this.vleid = parsedData.CitizenID;
        this.logouttitle = 'Logout of VLE';
      }
      this.menuitems = [
        { path: '/citizen/details', text: 'My Information' },
        { path: '/citizen/scheme/dashboard', text: 'My Dashboard' },
        { path: '/citizen/consenthistory', text: 'Consent Management' },
        { path: '/citizen/support', text: 'Support' },
        { path: '/home/user-manual', text: 'Help' },
        { path: '/citizen/scheme/attribute-applications', text: 'History of Attribute' }
      ];
    } else if (this.consentAccessService.isVLEuser) {
      this.visiblevleid = false;
      this.vleid = '';
      this.logouttitle = 'Logout of VLE';
      this.menuitems = [
        { path: '/vle/my-dashboard', text: 'My Dashboard' },
        { path: '/vle/citizen-service', text: 'Citizen Service' },
      ];
    } else if (
      this.consentAccessService.isLoggedIn == false &&
      (parsedData.citizen_unique_id == undefined ||
        parsedData.citizen_unique_id == null)
    ) {
      this.visiblevleid = false;
      this.vleid = '';
      this.menuitems = [
        { path: '/home/landing', text: 'Home' },
        { path: '/home/about-mh-ucdh', text: 'About Us' },
        {
          text: 'Gallery',
          children: [
            { path: '/home/gallery', queryParams: { tab: 'photo' }, text: 'Photo Gallery' },
            { path: '/home/gallery', queryParams: { tab: 'video' }, text: 'Video Gallery' },
          ],
        },
        {
          text: 'Help',
          children: [
            { path: '/home/user-manual', text: 'Help' },
            { path: '/home/support', text: 'Support' },
            { path: '/home/faqs', text: 'FAQs' },
            { path: '/home/contact-us', text: 'Contact Us' },
          ],
        },
      ];
    }
  }

  isDropdownActive(item: any): boolean {
    if (!item.children) {
      return false;
    }
    const currentPath = this.router.url.split('?')[0];
    return item.children.some((child: any) => child.path === currentPath);
  }

  LogOut() {
    this.consentAccessService.isLoggedIn = false;
    this.SwitchMenu();

    var data: any = sessionStorage.getItem('userData');
    data = JSON.parse(data);

    sessionStorage.clear();

    this.loginService.IDAMlogOut(data.idToken).subscribe((res: any) => {
      let bearertoken = data.access_token;
       this.loginService.fn_AddBearerTokenAuditLog(bearertoken)
      .subscribe(() => {
        // Only redirect AFTER audit log API completes
        window.location.href = res;
      }, (err) => {
        console.error('Audit log failed', err);
        // Still redirect even if logging fails
        window.location.href = res;
      });

    });
  }
  // loginMahaSSO() {
  //   var data = {
  //     maha_id: '',
  //     password: '',
  //     language: this.activeLanguage,
  //   };
  //   //this.citizenregistration();
  //   this.loginService.loginMahaSSO(data).subscribe((res: any) => {
  //     window.location.href = res;
  //   });
  //   //temp
  //   // this.route.navigate(['/citizen/details']);
  //   // this.consentAccessService.isLoggedIn = true;
  // }


  departmentLogin() {
    var data = {
      maha_id: '001',
      password: 'test',
    };
    this.loginService.departmentLogin(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }
  // Panel Data
  loginOpenID() {
    var data = {
      maha_id: '001',
      password: 'test',
      language: this.activeLanguage,
    };
    this.loginService.loginOpenID(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }
  citizenregistration() {
    this.registerModal.openModal();
  }
  goToProfile() {
    this.router.navigate(['/citizen/profile']);
  }
  private listenToLanguageChanges() {
    this.langService.language$.subscribe((language: any) => {
      this.activeLanguage = language;
    });
  }
  RedirectToVLE() {
    this.visiblevleid = false;
    this.vleid = '';
    this.citizenData= null;
    this.router.navigate(['/vle/my-dashboard']);
  }
  // Notifications
  notifications = [];

  hasUnreadNotifications(): boolean {
    // Logic to check for unread notifications
    return this.notifications.length > 0; // Adjust logic based on your actual read/unread status
  }

  private GetCitizenNotification() {
    const data: any = JSON.parse(sessionStorage.getItem('userData'));
    console.log(data);
    let Body = {
      userid:
        data?.citizen_unique_id == null
          ? data?.CitizenID
          : data?.citizen_unique_id,
      usernotificationid: 0,
    };
    this.citizenService
      .getCitizenNotifications(Body)
      .subscribe((response: any) => {
        this.notificationRawData = response.data;
        this.ChangeLanguageSettings(this.notificationRawData);
      });
  }

  private updateCitizenNotificationStatus(notify: any) {
    const data: any = JSON.parse(sessionStorage.getItem('userData'));
    let Body = {
      userid:
        data?.citizen_unique_id == null
          ? data?.CitizenID
          : data?.citizen_unique_id,
      usernotificationid: notify?.id,
    };
    this.citizenService
      .updateCitizenNotifications(Body)
      .subscribe((response: any) => {
        if (data != null) {
          this.GetCitizenNotification();
        }
      });
  }

  private listenToNotifyChanges() {
    const connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(environment.CMSAPI.split('api/')[0] + 'chatnotify', {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    Object.defineProperty(WebSocket, 'OPEN', { value: 1 });
    connection
      .start()
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
    connection.on('GeneralCollaboration', () => {
      this.GetCitizenNotification();
    });
  }

  private SubscribeLanguage() {
    this.languageSubscription = this.langService.language$.subscribe(() => {
      this.ChangeLanguageSettings(this.notificationRawData);
    });
  }

  ngOnDestroy(): void {
    this.languageSubscription.unsubscribe();
    clearTimeout(this.welcomePopupTimeout);
    this.renderer.removeClass(document.body, 'has-marquee');
  }

  ngDoCheck(): void {
    const showMarquee = this.consentAccessService.isLoggedIn && !!this.citizenData;
    if (showMarquee) {
      this.renderer.addClass(document.body, 'has-marquee');
    } else {
      this.renderer.removeClass(document.body, 'has-marquee');
    }
  }

  private ChangeLanguageSettings(Notification: any) {
    if (Notification !== null) {
      // Empty this data
      this.notifications = [];

      const notificationsToShow = Notification.filter(
        (notification) => notification.isread === false,
      ); // Get the first 10 notifications
      this.notifications = notificationsToShow.map((data) => ({
        id: data.notificationid,
        title:
          this.langService.currentLanguage === 'en'
            ? data.name
            : data.namelocal,
        info:
          this.langService.currentLanguage === 'en'
            ? data.description
            : data.descriptionlocal,
        date: data.datetime,
        isExpanded: false,
        isread: data.isread,
      }));
      this.notifyCount = this.notifications.length;
    }
  }

  protected readMoreNotification(content: string, isExpanded: boolean) {
    if (isExpanded) {
      return content.length + 10;
    }
    return 75;
  }

  protected toggleNotification(isExpanded: boolean, id: number) {
    const index = this.notifications.findIndex((x: any) => id === x.id);
    const notify = this.notifications[index];

    // Update Notify On Runtime Call APIs
    if (!notify.isread) {
      this.notifications[index].isread = true;
      setTimeout(() => {
        this.updateCitizenNotificationStatus(notify);
      }, 15000);
    }

    if (isExpanded) {
      this.notifications[index].isExpanded = false;
    } else {
      this.notifications[index].isExpanded = true;
    }
  }
  consentRedirect(): void {
    this.onLogin();
  }
  onLogin() {
    let data = {
      userId: 'CitizenLogin',
      password: '',
    };
    this.loginService.loginOpenIDConsent(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }

  loginOpenIDVLE() {
    var data = {
      maha_id: '001',
      password: 'test',
      language: this.activeLanguage,
    };
    this.loginService.loginOpenIDVLE(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }
  async getProfile(citizen_unique_id): Promise<void> {
    try {
      const param = {
        username: '',
        citizen_unique_id: citizen_unique_id,
      };

      console.log(param);

      const response: any = await firstValueFrom(
        this.loginService.getProfileImage(param),
      );

      console.log(response);
      this.citizenData = response[0];
      this.checkAndShowWelcomePopup();
    } catch (error) {
      console.error('Profile fetch error:', error);
    }
  }

  showWelcomePopup: boolean = false;
  private welcomePopupTimeout: any;

  private checkAndShowWelcomePopup(): void {
    if (sessionStorage.getItem('showWelcomePopup') === 'true') {
      sessionStorage.removeItem('showWelcomePopup');
      this.showWelcomePopup = true;
      clearTimeout(this.welcomePopupTimeout);
      this.welcomePopupTimeout = setTimeout(() => {
        this.showWelcomePopup = false;
      }, 5000);
    }
  }

  closeWelcomePopup(): void {
    this.showWelcomePopup = false;
    clearTimeout(this.welcomePopupTimeout);
  }
    loginMahaSSO() {
    var data = {
      maha_id: '',
      password: '',
      language: this.activeLanguage,
    };
    this.loginService.loginMahaSSO(data).subscribe((res: any) => {
      window.location.href = res;
    });
  }

    openEkycModal() {
     this.router.navigate(['/ekyc-process']);
  }

  get headerDisplayName(): string {
    const fullname: string = this.citizenData?.fullname;
    if (!fullname) {
      return '';
    }
    const parts = fullname.trim().split(/\s+/);
    return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1]}` : parts[0];
  }
}
